// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Вкладка «Чат». Токены объявлены на .chat-page, тёмная тема
   подхватывается из общего data-theme на <html>.
   ============================================================ */

.chat-page {
  --ch-bg: #ffffff;
  --ch-bg-muted: #f4f4f5;
  --ch-bg-hover: #f4f4f5;
  --ch-border: rgba(15, 23, 42, 0.09);
  --ch-text: #09090b;
  --ch-text-muted: #71717a;
  --ch-bubble-in: #f4f4f5;
  --ch-bubble-out: #18181b;
  --ch-bubble-out-text: #fafafa;
  --ch-online: #22c55e;
  --ch-radius: 14px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0 24px;
  /* страница занимает высоту экрана: скроллится только лента сообщений */
  height: calc(100vh - var(--app-content-offset, 148px));
  min-height: 520px;
  color: var(--ch-text);
}

:root[data-theme='dark'] .chat-page {
  --ch-bg: #0a0a0a;
  --ch-bg-muted: #1c1c1f;
  --ch-bg-hover: #202024;
  --ch-border: rgba(148, 163, 184, 0.16);
  --ch-text: #fafafa;
  --ch-text-muted: #a1a1aa;
  --ch-bubble-in: #1c1c1f;
  --ch-bubble-out: #e4e4e7;
  --ch-bubble-out-text: #09090b;
  --ch-online: #22c55e;
}

.chat-page-title {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.chat-page-subtitle {
  margin: 4px 0 0;
  color: var(--ch-text-muted);
  font-size: 0.9rem;
}

/* ── Каркас: две колонки в одной карточке ── */
.chat-shell {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  border: 1px solid var(--ch-border);
  border-radius: var(--ch-radius);
  background: var(--ch-bg);
  overflow: hidden;
}

/* ── Левая колонка ── */
.chat-list {
  display: flex;
  flex-direction: column;
  min-width: 0;
  /* без min-height:0 grid-элемент растягивается под контент и внутренний скролл не работает */
  min-height: 0;
  overflow: hidden;
  border-right: 1px solid var(--ch-border);
}

.chat-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 12px;
}

.chat-list-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.chat-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px 12px;
  padding: 8px 12px;
  border: 1px solid var(--ch-border);
  border-radius: 10px;
  color: var(--ch-text-muted);
}

.chat-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--ch-text);
  font-size: 0.88rem;
}

.chat-list-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 10px 12px;
}

.chat-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 12px;
  color: var(--ch-text-muted);
  font-size: 0.88rem;
}

.chat-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 2px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.chat-list-item:hover {
  background: var(--ch-bg-hover);
}

.chat-list-item.active {
  background: var(--ch-bg-muted);
}

.chat-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 50%;
  background: var(--ch-bg-muted);
  border: 1px solid var(--ch-border);
  font-size: 0.8rem;
  font-weight: 700;
}

.chat-avatar--sm {
  width: 28px;
  height: 28px;
  flex-basis: 28px;
  font-size: 0.68rem;
}

.chat-list-main {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1 1;
}

.chat-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.chat-list-name {
  font-weight: 600;
  font-size: 0.92rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-list-date {
  color: var(--ch-text-muted);
  font-size: 0.72rem;
  white-space: nowrap;
}

.chat-list-preview {
  color: var(--ch-text-muted);
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-list-marks {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ch-text-muted);
}

.chat-mark {
  display: inline-flex;
  cursor: pointer;
}

.chat-unread {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--ch-bubble-out);
  color: var(--ch-bubble-out-text);
  font-size: 0.72rem;
  font-weight: 700;
}

/* ── Правая колонка ── */
.chat-window {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.chat-window--empty {
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--ch-text-muted);
}

.chat-window-head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--ch-border);
}

.chat-window-titles {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.chat-window-name {
  font-weight: 700;
  font-size: 0.98rem;
}

.chat-window-status {
  font-size: 0.8rem;
  color: var(--ch-text-muted);
}

.chat-window-status.online {
  color: var(--ch-online);
}

.chat-window-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-offline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--ch-text-muted);
  font-size: 0.75rem;
}

.chat-menu-wrap {
  position: relative;
}

.chat-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 20;
  min-width: 220px;
  padding: 6px;
  border: 1px solid var(--ch-border);
  border-radius: 12px;
  background: var(--ch-bg);
  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);
}

.chat-menu button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--ch-text);
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}

.chat-menu button:hover {
  background: var(--ch-bg-hover);
}

/* ── Лента сообщений ── */
.chat-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.chat-loading-older {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.chat-day {
  display: flex;
  justify-content: center;
  margin: 14px 0;
}

.chat-day span {
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid var(--ch-border);
  background: var(--ch-bg);
  color: var(--ch-text-muted);
  font-size: 0.76rem;
}

.chat-msg-slot {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.chat-msg-slot.own {
  align-items: flex-end;
}

.chat-msg-slot.group-start {
  margin-top: 12px;
}

.chat-msg-author {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: var(--ch-text);
  font-size: 0.85rem;
  font-weight: 600;
}

.chat-msg-row {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: min(680px, 82%);
}

.chat-msg-row.own {
  flex-direction: row-reverse;
  margin-left: auto;
}

.chat-msg-body {
  min-width: 0;
}

.chat-bubble {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 12px;
  background: var(--ch-bubble-in);
  color: var(--ch-text);
  font-size: 0.9rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.chat-bubble.own {
  background: var(--ch-bubble-out);
  color: var(--ch-bubble-out-text);
}

.chat-bubble.failed {
  outline: 1px solid var(--accent-error, #dc2626);
}

.chat-bubble-text {
  white-space: pre-wrap;
}

.chat-bubble-time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  opacity: 0.65;
}

.chat-bubble.own .chat-bubble-time {
  align-self: flex-end;
}

.chat-msg-highlight {
  animation: chat-highlight 1.2s ease;
}

@keyframes chat-highlight {
  0% { background: rgba(59, 130, 246, 0.18); }
  100% { background: transparent; }
}

/* Цитата ответа */
.chat-reply-quote {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  opacity: 0.8;
  font-size: 0.82rem;
}

.chat-reply-quote-bar {
  width: 3px;
  border-radius: 2px;
  background: currentColor;
  opacity: 0.5;
  flex: 0 0 3px;
}

.chat-reply-quote-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Реакции */
.chat-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: -4px;
  padding: 6px 2px 0;
}

.chat-reactions.own {
  justify-content: flex-end;
}

.chat-reaction {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--ch-border);
  background: var(--ch-bg);
  color: var(--ch-text);
  font-size: 0.78rem;
  cursor: pointer;
}

.chat-reaction.mine {
  border-color: var(--accent-primary, #2563eb);
}

.chat-reaction-count {
  font-weight: 700;
}

/* Инструменты у сообщения */
.chat-msg-tools {
  position: relative;
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.chat-msg-row:hover .chat-msg-tools {
  opacity: 1;
}

.chat-tool-btn {
  display: inline-flex;
  padding: 4px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--ch-text-muted);
  cursor: pointer;
}

.chat-tool-btn:hover {
  background: var(--ch-bg-hover);
}

.chat-reaction-picker,
.chat-emoji-picker {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  z-index: 25;
  display: flex;
  gap: 2px;
  padding: 6px;
  border: 1px solid var(--ch-border);
  border-radius: 999px;
  background: var(--ch-bg);
  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);
}

.chat-reaction-picker button,
.chat-emoji-picker button {
  border: none;
  background: transparent;
  font-size: 1.05rem;
  line-height: 1;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.chat-reaction-picker button:hover,
.chat-emoji-picker button:hover {
  background: var(--ch-bg-hover);
}

.chat-emoji-picker {
  flex-wrap: wrap;
  width: 200px;
  border-radius: 12px;
}

/* Вложения */
.chat-image-btn {
  padding: 0;
  border: none;
  background: transparent;
  cursor: zoom-in;
}

.chat-image {
  display: block;
  max-width: 320px;
  max-height: 320px;
  border-radius: 10px;
}

.chat-file {
  display: flex;
  align-items: center;
  gap: 10px;
  color: inherit;
  text-decoration: none;
}

.chat-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(127, 127, 127, 0.18);
}

.chat-file-meta {
  display: flex;
  flex-direction: column;
}

.chat-file-name {
  font-weight: 600;
}

.chat-file-size {
  font-size: 0.75rem;
  opacity: 0.7;
}

/* Голосовые */
.chat-voice {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
}

.chat-voice-play {
  display: inline-flex;
  padding: 6px;
  border: none;
  border-radius: 50%;
  background: rgba(127, 127, 127, 0.2);
  color: inherit;
  cursor: pointer;
}

.chat-voice-wave {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 28px;
  flex: 1 1;
  cursor: pointer;
}

.chat-voice-bar {
  flex: 1 1;
  min-width: 2px;
  border-radius: 2px;
  background: currentColor;
  opacity: 0.35;
}

.chat-voice-bar.played {
  opacity: 0.9;
}

.chat-voice-time {
  font-size: 0.74rem;
  opacity: 0.7;
  font-variant-numeric: tabular-nums;
}

/* Индикатор «печатает» */
.chat-typing {
  display: inline-flex;
  gap: 4px;
  padding: 10px 14px;
  margin-top: 8px;
  width: fit-content;
  border-radius: 12px;
  background: var(--ch-bubble-in);
}

.chat-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ch-text-muted);
  animation: chat-typing-bounce 1.2s infinite ease-in-out;
}

.chat-typing span:nth-child(2) { animation-delay: 0.15s; }
.chat-typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes chat-typing-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
  30% { transform: translateY(-4px); opacity: 1; }
}

/* ── Поле ввода ── */
.chat-composer {
  flex: 0 0 auto;
  border-top: 1px solid var(--ch-border);
  padding: 12px 16px;
}

.chat-composer-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-composer-reply {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--ch-bg-muted);
  font-size: 0.82rem;
  color: var(--ch-text-muted);
}

.chat-composer-reply button {
  margin-left: auto;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.chat-composer-error {
  margin-bottom: 8px;
  color: var(--accent-error, #dc2626);
  font-size: 0.8rem;
}

.chat-upload {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.chat-upload-bar {
  flex: 1 1;
  height: 6px;
  border-radius: 999px;
  background: var(--ch-bg-muted);
  overflow: hidden;
}

.chat-upload-fill {
  display: block;
  height: 100%;
  background: var(--accent-primary, #2563eb);
  transition: width 0.2s ease;
}

.chat-upload-value {
  font-size: 0.75rem;
  color: var(--ch-text-muted);
  font-variant-numeric: tabular-nums;
}

.chat-input {
  flex: 1 1;
  min-width: 0;
  max-height: 120px;
  padding: 11px 14px;
  border: 1px solid var(--ch-border);
  border-radius: 999px;
  background: var(--ch-bg);
  color: var(--ch-text);
  font-family: inherit;
  font-size: 0.9rem;
  resize: none;
  outline: none;
}

.chat-input:focus {
  border-color: var(--accent-primary, #2563eb);
}

.chat-icon-btn {
  display: inline-flex;
  padding: 8px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--ch-text-muted);
  cursor: pointer;
}

.chat-icon-btn:hover:not(:disabled) {
  background: var(--ch-bg-hover);
  color: var(--ch-text);
}

.chat-icon-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.chat-send-btn {
  display: inline-flex;
  padding: 9px;
  border: none;
  border-radius: 50%;
  background: var(--ch-bubble-out);
  color: var(--ch-bubble-out-text);
  cursor: pointer;
}

.chat-emoji-wrap {
  position: relative;
}

.chat-recording {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-recording-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent-error, #dc2626);
  animation: chat-rec 1s infinite;
}

.chat-recording-time {
  flex: 1 1;
  font-variant-numeric: tabular-nums;
  font-size: 0.85rem;
}

@keyframes chat-rec {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* ── Адаптив ── */
@media (max-width: 900px) {
  /* На узких экранах колонки складываются, страница скроллится целиком. */
  .chat-page {
    height: auto;
  }

  .chat-shell {
    grid-template-columns: 1fr;
    height: auto;
  }

  .chat-list {
    border-right: none;
    border-bottom: 1px solid var(--ch-border);
    max-height: 320px;
  }

  .chat-window {
    max-height: 75vh;
  }

  .chat-scroll {
    min-height: 50vh;
  }

  .chat-msg-row {
    max-width: 92%;
  }
}

/* Аватар с индикатором онлайна (как в референсе) */
.chat-avatar-wrap {
  position: relative;
  display: inline-flex;
  flex: 0 0 42px;
}

.chat-online-dot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--ch-online);
  border: 2px solid var(--ch-bg);
}

/* ── Диалог «новый чат» ── */
.chat-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.chat-modal {
  width: min(460px, 100%);
  max-height: min(620px, 90vh);
  display: flex;
  flex-direction: column;
  border: 1px solid var(--ch-border, rgba(148, 163, 184, 0.2));
  border-radius: 16px;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, #0f172a);
  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.chat-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 10px;
}

.chat-modal-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.chat-modal-subtitle {
  margin: 4px 0 0;
  color: var(--text-secondary, #64748b);
  font-size: 0.84rem;
}

.chat-modal-search {
  margin: 0 18px 12px;
}

.chat-role-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 18px 12px;
}

.chat-role-chip {
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  background: transparent;
  color: var(--text-secondary, #64748b);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-role-chip.active {
  background: var(--text-primary, #18181b);
  border-color: var(--text-primary, #18181b);
  color: var(--bg-primary, #fff);
}

.chat-modal-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 10px 14px;
}

.chat-modal-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.chat-modal-item:hover:not(:disabled) {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));
}

.chat-modal-item:disabled {
  opacity: 0.6;
  cursor: default;
}

.chat-modal-item-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.chat-new-chat-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid var(--ch-border);
  background: transparent;
  color: var(--ch-text);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-new-chat-btn:hover {
  background: var(--ch-bg-hover);
}

/* ── Статус realtime-соединения ── */
.chat-connection {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid var(--ch-border);
  border-radius: 10px;
  background: var(--ch-bg-muted);
  color: var(--ch-text-muted);
  font-size: 0.84rem;
}

.chat-connection-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent-warning, #d97706);
  flex: 0 0 8px;
}

.chat-connection--connecting .chat-connection-dot,
.chat-connection--reconnecting .chat-connection-dot {
  animation: chat-rec 1.2s infinite;
}

.chat-connection--failed .chat-connection-dot {
  background: var(--accent-error, #dc2626);
}

.chat-connection-retry {
  margin-left: auto;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--ch-border);
  background: transparent;
  color: var(--ch-text);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-connection-retry:hover {
  background: var(--ch-bg-hover);
}

/* Галочки доставки/прочтения на своих сообщениях */
.chat-check {
  opacity: 0.75;
}

.chat-check--read {
  color: #3b82f6;
  opacity: 1;
}

/* ── Группы: аватары, системные сообщения, панель участников ── */
.chat-list-head-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.chat-empty-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.chat-avatar--img {
  object-fit: cover;
  padding: 0;
}

.chat-avatar--group {
  background: var(--ch-bubble-out);
  color: var(--ch-bubble-out-text);
  border-color: transparent;
  font-size: 1rem;
}

.chat-avatar--collage {
  position: relative;
  overflow: hidden;
  padding: 0;
  display: grid;
  gap: 1px;
  grid-template-columns: 1fr 1fr;
}

.chat-avatar--collage.count-2 {
  grid-template-columns: 1fr 1fr;
}

.chat-avatar--collage.count-3 img:first-child {
  grid-row: span 2;
}

.chat-avatar--collage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Системное событие: по центру, мелким серым, без пузыря */
.chat-system {
  display: flex;
  justify-content: center;
  margin: 10px 0;
  padding: 0 24px;
  text-align: center;
}

.chat-system span {
  color: var(--ch-text-muted);
  font-size: 0.78rem;
  line-height: 1.4;
}

/* Переименование группы */
.chat-window-name.editable {
  cursor: pointer;
}

.chat-window-name.editable:hover {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

.chat-rename {
  display: flex;
  align-items: center;
  gap: 6px;
}

.chat-members-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid var(--ch-border);
  background: transparent;
  color: var(--ch-text);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-members-btn:hover,
.chat-members-btn.active {
  background: var(--ch-bg-muted);
}

/* Раскладка: лента + панель участников справа */
.chat-window-body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.chat-window-main {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
}

.chat-participants {
  display: flex;
  flex-direction: column;
  width: 280px;
  flex: 0 0 280px;
  min-height: 0;
  border-left: 1px solid var(--ch-border);
  background: var(--ch-bg);
}

.chat-participants-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px 10px;
}

.chat-participants-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
}

.chat-participants-count {
  margin: 2px 0 0;
  color: var(--ch-text-muted);
  font-size: 0.78rem;
}

.chat-participants-add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 16px 10px;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid var(--ch-border);
  background: transparent;
  color: var(--ch-text);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-participants-add:hover {
  background: var(--ch-bg-hover);
}

.chat-participants-list {
  list-style: none;
  margin: 0;
  padding: 0 8px 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.chat-participant {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px;
  border-radius: 10px;
}

.chat-participant:hover {
  background: var(--ch-bg-hover);
}

.chat-participant-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.chat-participant-you {
  margin-left: 6px;
  color: var(--ch-text-muted);
  font-weight: 500;
  font-size: 0.76rem;
}

.chat-participant-role {
  color: var(--ch-text-muted);
  font-size: 0.75rem;
}

.chat-participants-foot {
  padding: 12px 16px;
  border-top: 1px solid var(--ch-border);
}

.chat-participants-confirm {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.chat-leave-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid var(--accent-error, #dc2626);
  background: transparent;
  color: var(--accent-error, #dc2626);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-leave-btn:hover {
  background: rgba(220, 38, 38, 0.08);
}

/* Диалог выбора людей: название, чипы выбранных, футер */
.chat-modal-field {
  position: relative;
  margin: 0 18px 12px;
}

.chat-modal-input {
  width: 100%;
  padding: 9px 60px 9px 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  border-radius: 10px;
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-size: 0.9rem;
  outline: none;
}

.chat-modal-counter {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary, #64748b);
  font-size: 0.72rem;
}

.chat-selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 18px 10px;
}

.chat-selected-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));
  background: transparent;
  color: inherit;
  font-size: 0.78rem;
  cursor: pointer;
}

.chat-check-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 5px;
  border: 1.5px solid var(--border-color, rgba(148, 163, 184, 0.5));
  color: #fff;
}

.chat-check-box.checked {
  background: var(--accent-primary, #2563eb);
  border-color: var(--accent-primary, #2563eb);
}

.chat-modal-item.selected {
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));
}

.chat-modal-foot {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));
}

.chat-modal-hint {
  color: var(--text-secondary, #64748b);
  font-size: 0.8rem;
}

.chat-modal-submit {
  margin-left: auto;
  padding: 9px 16px;
  border-radius: 10px;
  border: none;
  background: var(--text-primary, #18181b);
  color: var(--bg-primary, #fff);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.chat-modal-submit:disabled {
  opacity: 0.45;
  cursor: default;
}

@media (max-width: 900px) {
  .chat-participants {
    width: 100%;
    flex-basis: auto;
  }

  .chat-window-body {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/chat/chat.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uEAAuE;EACvE,sDAAsD;EACtD,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4FAA4F;EAC5F,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,KAAK,oCAAoC,EAAE;EAC3C,OAAO,uBAAuB,EAAE;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,qBAAqB,EAAE;;AAExD;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,kBAAkB;AAClB;EACE,wEAAwE;EACxE;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,4DAA4D;EAC5D,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+DAA+D;EAC/D,uBAAuB;EACvB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+DAA+D;EAC/D,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+DAA+D;EAC/D,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iEAAiE;EACjE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ============================================================\n   Вкладка «Чат». Токены объявлены на .chat-page, тёмная тема\n   подхватывается из общего data-theme на <html>.\n   ============================================================ */\n\n.chat-page {\n  --ch-bg: #ffffff;\n  --ch-bg-muted: #f4f4f5;\n  --ch-bg-hover: #f4f4f5;\n  --ch-border: rgba(15, 23, 42, 0.09);\n  --ch-text: #09090b;\n  --ch-text-muted: #71717a;\n  --ch-bubble-in: #f4f4f5;\n  --ch-bubble-out: #18181b;\n  --ch-bubble-out-text: #fafafa;\n  --ch-online: #22c55e;\n  --ch-radius: 14px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 8px 0 24px;\n  /* страница занимает высоту экрана: скроллится только лента сообщений */\n  height: calc(100vh - var(--app-content-offset, 148px));\n  min-height: 520px;\n  color: var(--ch-text);\n}\n\n:root[data-theme='dark'] .chat-page {\n  --ch-bg: #0a0a0a;\n  --ch-bg-muted: #1c1c1f;\n  --ch-bg-hover: #202024;\n  --ch-border: rgba(148, 163, 184, 0.16);\n  --ch-text: #fafafa;\n  --ch-text-muted: #a1a1aa;\n  --ch-bubble-in: #1c1c1f;\n  --ch-bubble-out: #e4e4e7;\n  --ch-bubble-out-text: #09090b;\n  --ch-online: #22c55e;\n}\n\n.chat-page-title {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.chat-page-subtitle {\n  margin: 4px 0 0;\n  color: var(--ch-text-muted);\n  font-size: 0.9rem;\n}\n\n/* ── Каркас: две колонки в одной карточке ── */\n.chat-shell {\n  display: grid;\n  grid-template-columns: 320px minmax(0, 1fr);\n  flex: 1 1 auto;\n  min-height: 0;\n  border: 1px solid var(--ch-border);\n  border-radius: var(--ch-radius);\n  background: var(--ch-bg);\n  overflow: hidden;\n}\n\n/* ── Левая колонка ── */\n.chat-list {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  /* без min-height:0 grid-элемент растягивается под контент и внутренний скролл не работает */\n  min-height: 0;\n  overflow: hidden;\n  border-right: 1px solid var(--ch-border);\n}\n\n.chat-list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 18px 12px;\n}\n\n.chat-list-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.chat-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 16px 12px;\n  padding: 8px 12px;\n  border: 1px solid var(--ch-border);\n  border-radius: 10px;\n  color: var(--ch-text-muted);\n}\n\n.chat-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.88rem;\n}\n\n.chat-list-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 10px 12px;\n}\n\n.chat-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 12px;\n  color: var(--ch-text-muted);\n  font-size: 0.88rem;\n}\n\n.chat-list-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  margin-bottom: 2px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chat-list-item:hover {\n  background: var(--ch-bg-hover);\n}\n\n.chat-list-item.active {\n  background: var(--ch-bg-muted);\n}\n\n.chat-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border-radius: 50%;\n  background: var(--ch-bg-muted);\n  border: 1px solid var(--ch-border);\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.chat-avatar--sm {\n  width: 28px;\n  height: 28px;\n  flex-basis: 28px;\n  font-size: 0.68rem;\n}\n\n.chat-list-main {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.chat-list-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n\n.chat-list-name {\n  font-weight: 600;\n  font-size: 0.92rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-list-date {\n  color: var(--ch-text-muted);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.chat-list-preview {\n  color: var(--ch-text-muted);\n  font-size: 0.82rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-list-marks {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--ch-text-muted);\n}\n\n.chat-mark {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.chat-unread {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--ch-bubble-out);\n  color: var(--ch-bubble-out-text);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n/* ── Правая колонка ── */\n.chat-window {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chat-window--empty {\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--ch-text-muted);\n}\n\n.chat-window-head {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--ch-border);\n}\n\n.chat-window-titles {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.chat-window-name {\n  font-weight: 700;\n  font-size: 0.98rem;\n}\n\n.chat-window-status {\n  font-size: 0.8rem;\n  color: var(--ch-text-muted);\n}\n\n.chat-window-status.online {\n  color: var(--ch-online);\n}\n\n.chat-window-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-offline {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--ch-text-muted);\n  font-size: 0.75rem;\n}\n\n.chat-menu-wrap {\n  position: relative;\n}\n\n.chat-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 20;\n  min-width: 220px;\n  padding: 6px;\n  border: 1px solid var(--ch-border);\n  border-radius: 12px;\n  background: var(--ch-bg);\n  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);\n}\n\n.chat-menu button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chat-menu button:hover {\n  background: var(--ch-bg-hover);\n}\n\n/* ── Лента сообщений ── */\n.chat-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.chat-loading-older {\n  display: flex;\n  justify-content: center;\n  padding: 8px 0;\n}\n\n.chat-day {\n  display: flex;\n  justify-content: center;\n  margin: 14px 0;\n}\n\n.chat-day span {\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--ch-border);\n  background: var(--ch-bg);\n  color: var(--ch-text-muted);\n  font-size: 0.76rem;\n}\n\n.chat-msg-slot {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.chat-msg-slot.own {\n  align-items: flex-end;\n}\n\n.chat-msg-slot.group-start {\n  margin-top: 12px;\n}\n\n.chat-msg-author {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  color: var(--ch-text);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.chat-msg-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: min(680px, 82%);\n}\n\n.chat-msg-row.own {\n  flex-direction: row-reverse;\n  margin-left: auto;\n}\n\n.chat-msg-body {\n  min-width: 0;\n}\n\n.chat-bubble {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: var(--ch-bubble-in);\n  color: var(--ch-text);\n  font-size: 0.9rem;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.chat-bubble.own {\n  background: var(--ch-bubble-out);\n  color: var(--ch-bubble-out-text);\n}\n\n.chat-bubble.failed {\n  outline: 1px solid var(--accent-error, #dc2626);\n}\n\n.chat-bubble-text {\n  white-space: pre-wrap;\n}\n\n.chat-bubble-time {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.72rem;\n  opacity: 0.65;\n}\n\n.chat-bubble.own .chat-bubble-time {\n  align-self: flex-end;\n}\n\n.chat-msg-highlight {\n  animation: chat-highlight 1.2s ease;\n}\n\n@keyframes chat-highlight {\n  0% { background: rgba(59, 130, 246, 0.18); }\n  100% { background: transparent; }\n}\n\n/* Цитата ответа */\n.chat-reply-quote {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  opacity: 0.8;\n  font-size: 0.82rem;\n}\n\n.chat-reply-quote-bar {\n  width: 3px;\n  border-radius: 2px;\n  background: currentColor;\n  opacity: 0.5;\n  flex: 0 0 3px;\n}\n\n.chat-reply-quote-text {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n/* Реакции */\n.chat-reactions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: -4px;\n  padding: 6px 2px 0;\n}\n\n.chat-reactions.own {\n  justify-content: flex-end;\n}\n\n.chat-reaction {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--ch-border);\n  background: var(--ch-bg);\n  color: var(--ch-text);\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n.chat-reaction.mine {\n  border-color: var(--accent-primary, #2563eb);\n}\n\n.chat-reaction-count {\n  font-weight: 700;\n}\n\n/* Инструменты у сообщения */\n.chat-msg-tools {\n  position: relative;\n  display: flex;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n.chat-msg-row:hover .chat-msg-tools {\n  opacity: 1;\n}\n\n.chat-tool-btn {\n  display: inline-flex;\n  padding: 4px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--ch-text-muted);\n  cursor: pointer;\n}\n\n.chat-tool-btn:hover {\n  background: var(--ch-bg-hover);\n}\n\n.chat-reaction-picker,\n.chat-emoji-picker {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 0;\n  z-index: 25;\n  display: flex;\n  gap: 2px;\n  padding: 6px;\n  border: 1px solid var(--ch-border);\n  border-radius: 999px;\n  background: var(--ch-bg);\n  box-shadow: 0 12px 32px -14px rgba(0, 0, 0, 0.45);\n}\n\n.chat-reaction-picker button,\n.chat-emoji-picker button {\n  border: none;\n  background: transparent;\n  font-size: 1.05rem;\n  line-height: 1;\n  padding: 4px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.chat-reaction-picker button:hover,\n.chat-emoji-picker button:hover {\n  background: var(--ch-bg-hover);\n}\n\n.chat-emoji-picker {\n  flex-wrap: wrap;\n  width: 200px;\n  border-radius: 12px;\n}\n\n/* Вложения */\n.chat-image-btn {\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: zoom-in;\n}\n\n.chat-image {\n  display: block;\n  max-width: 320px;\n  max-height: 320px;\n  border-radius: 10px;\n}\n\n.chat-file {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: inherit;\n  text-decoration: none;\n}\n\n.chat-file-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: rgba(127, 127, 127, 0.18);\n}\n\n.chat-file-meta {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-file-name {\n  font-weight: 600;\n}\n\n.chat-file-size {\n  font-size: 0.75rem;\n  opacity: 0.7;\n}\n\n/* Голосовые */\n.chat-voice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 220px;\n}\n\n.chat-voice-play {\n  display: inline-flex;\n  padding: 6px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(127, 127, 127, 0.2);\n  color: inherit;\n  cursor: pointer;\n}\n\n.chat-voice-wave {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  height: 28px;\n  flex: 1;\n  cursor: pointer;\n}\n\n.chat-voice-bar {\n  flex: 1;\n  min-width: 2px;\n  border-radius: 2px;\n  background: currentColor;\n  opacity: 0.35;\n}\n\n.chat-voice-bar.played {\n  opacity: 0.9;\n}\n\n.chat-voice-time {\n  font-size: 0.74rem;\n  opacity: 0.7;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Индикатор «печатает» */\n.chat-typing {\n  display: inline-flex;\n  gap: 4px;\n  padding: 10px 14px;\n  margin-top: 8px;\n  width: fit-content;\n  border-radius: 12px;\n  background: var(--ch-bubble-in);\n}\n\n.chat-typing span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--ch-text-muted);\n  animation: chat-typing-bounce 1.2s infinite ease-in-out;\n}\n\n.chat-typing span:nth-child(2) { animation-delay: 0.15s; }\n.chat-typing span:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes chat-typing-bounce {\n  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }\n  30% { transform: translateY(-4px); opacity: 1; }\n}\n\n/* ── Поле ввода ── */\n.chat-composer {\n  flex: 0 0 auto;\n  border-top: 1px solid var(--ch-border);\n  padding: 12px 16px;\n}\n\n.chat-composer-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-composer-reply {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: var(--ch-bg-muted);\n  font-size: 0.82rem;\n  color: var(--ch-text-muted);\n}\n\n.chat-composer-reply button {\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.chat-composer-error {\n  margin-bottom: 8px;\n  color: var(--accent-error, #dc2626);\n  font-size: 0.8rem;\n}\n\n.chat-upload {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.chat-upload-bar {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--ch-bg-muted);\n  overflow: hidden;\n}\n\n.chat-upload-fill {\n  display: block;\n  height: 100%;\n  background: var(--accent-primary, #2563eb);\n  transition: width 0.2s ease;\n}\n\n.chat-upload-value {\n  font-size: 0.75rem;\n  color: var(--ch-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.chat-input {\n  flex: 1;\n  min-width: 0;\n  max-height: 120px;\n  padding: 11px 14px;\n  border: 1px solid var(--ch-border);\n  border-radius: 999px;\n  background: var(--ch-bg);\n  color: var(--ch-text);\n  font-family: inherit;\n  font-size: 0.9rem;\n  resize: none;\n  outline: none;\n}\n\n.chat-input:focus {\n  border-color: var(--accent-primary, #2563eb);\n}\n\n.chat-icon-btn {\n  display: inline-flex;\n  padding: 8px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--ch-text-muted);\n  cursor: pointer;\n}\n\n.chat-icon-btn:hover:not(:disabled) {\n  background: var(--ch-bg-hover);\n  color: var(--ch-text);\n}\n\n.chat-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.chat-send-btn {\n  display: inline-flex;\n  padding: 9px;\n  border: none;\n  border-radius: 50%;\n  background: var(--ch-bubble-out);\n  color: var(--ch-bubble-out-text);\n  cursor: pointer;\n}\n\n.chat-emoji-wrap {\n  position: relative;\n}\n\n.chat-recording {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-recording-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--accent-error, #dc2626);\n  animation: chat-rec 1s infinite;\n}\n\n.chat-recording-time {\n  flex: 1;\n  font-variant-numeric: tabular-nums;\n  font-size: 0.85rem;\n}\n\n@keyframes chat-rec {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n/* ── Адаптив ── */\n@media (max-width: 900px) {\n  /* На узких экранах колонки складываются, страница скроллится целиком. */\n  .chat-page {\n    height: auto;\n  }\n\n  .chat-shell {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n\n  .chat-list {\n    border-right: none;\n    border-bottom: 1px solid var(--ch-border);\n    max-height: 320px;\n  }\n\n  .chat-window {\n    max-height: 75vh;\n  }\n\n  .chat-scroll {\n    min-height: 50vh;\n  }\n\n  .chat-msg-row {\n    max-width: 92%;\n  }\n}\n\n/* Аватар с индикатором онлайна (как в референсе) */\n.chat-avatar-wrap {\n  position: relative;\n  display: inline-flex;\n  flex: 0 0 42px;\n}\n\n.chat-online-dot {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: var(--ch-online);\n  border: 2px solid var(--ch-bg);\n}\n\n/* ── Диалог «новый чат» ── */\n.chat-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n.chat-modal {\n  width: min(460px, 100%);\n  max-height: min(620px, 90vh);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--ch-border, rgba(148, 163, 184, 0.2));\n  border-radius: 16px;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, #0f172a);\n  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.chat-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 18px 10px;\n}\n\n.chat-modal-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.chat-modal-subtitle {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.84rem;\n}\n\n.chat-modal-search {\n  margin: 0 18px 12px;\n}\n\n.chat-role-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 18px 12px;\n}\n\n.chat-role-chip {\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  background: transparent;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-role-chip.active {\n  background: var(--text-primary, #18181b);\n  border-color: var(--text-primary, #18181b);\n  color: var(--bg-primary, #fff);\n}\n\n.chat-modal-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 10px 14px;\n}\n\n.chat-modal-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chat-modal-item:hover:not(:disabled) {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));\n}\n\n.chat-modal-item:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.chat-modal-item-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.chat-new-chat-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--ch-border);\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-new-chat-btn:hover {\n  background: var(--ch-bg-hover);\n}\n\n/* ── Статус realtime-соединения ── */\n.chat-connection {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: 1px solid var(--ch-border);\n  border-radius: 10px;\n  background: var(--ch-bg-muted);\n  color: var(--ch-text-muted);\n  font-size: 0.84rem;\n}\n\n.chat-connection-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--accent-warning, #d97706);\n  flex: 0 0 8px;\n}\n\n.chat-connection--connecting .chat-connection-dot,\n.chat-connection--reconnecting .chat-connection-dot {\n  animation: chat-rec 1.2s infinite;\n}\n\n.chat-connection--failed .chat-connection-dot {\n  background: var(--accent-error, #dc2626);\n}\n\n.chat-connection-retry {\n  margin-left: auto;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--ch-border);\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-connection-retry:hover {\n  background: var(--ch-bg-hover);\n}\n\n/* Галочки доставки/прочтения на своих сообщениях */\n.chat-check {\n  opacity: 0.75;\n}\n\n.chat-check--read {\n  color: #3b82f6;\n  opacity: 1;\n}\n\n/* ── Группы: аватары, системные сообщения, панель участников ── */\n.chat-list-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.chat-empty-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n}\n\n.chat-avatar--img {\n  object-fit: cover;\n  padding: 0;\n}\n\n.chat-avatar--group {\n  background: var(--ch-bubble-out);\n  color: var(--ch-bubble-out-text);\n  border-color: transparent;\n  font-size: 1rem;\n}\n\n.chat-avatar--collage {\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n  display: grid;\n  gap: 1px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.chat-avatar--collage.count-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.chat-avatar--collage.count-3 img:first-child {\n  grid-row: span 2;\n}\n\n.chat-avatar--collage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Системное событие: по центру, мелким серым, без пузыря */\n.chat-system {\n  display: flex;\n  justify-content: center;\n  margin: 10px 0;\n  padding: 0 24px;\n  text-align: center;\n}\n\n.chat-system span {\n  color: var(--ch-text-muted);\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n/* Переименование группы */\n.chat-window-name.editable {\n  cursor: pointer;\n}\n\n.chat-window-name.editable:hover {\n  text-decoration: underline dotted;\n}\n\n.chat-rename {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chat-members-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--ch-border);\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-members-btn:hover,\n.chat-members-btn.active {\n  background: var(--ch-bg-muted);\n}\n\n/* Раскладка: лента + панель участников справа */\n.chat-window-body {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.chat-window-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n}\n\n.chat-participants {\n  display: flex;\n  flex-direction: column;\n  width: 280px;\n  flex: 0 0 280px;\n  min-height: 0;\n  border-left: 1px solid var(--ch-border);\n  background: var(--ch-bg);\n}\n\n.chat-participants-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 14px 16px 10px;\n}\n\n.chat-participants-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.chat-participants-count {\n  margin: 2px 0 0;\n  color: var(--ch-text-muted);\n  font-size: 0.78rem;\n}\n\n.chat-participants-add {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 0 16px 10px;\n  padding: 9px 12px;\n  border-radius: 10px;\n  border: 1px solid var(--ch-border);\n  background: transparent;\n  color: var(--ch-text);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-participants-add:hover {\n  background: var(--ch-bg-hover);\n}\n\n.chat-participants-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 8px 12px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.chat-participant {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 8px;\n  border-radius: 10px;\n}\n\n.chat-participant:hover {\n  background: var(--ch-bg-hover);\n}\n\n.chat-participant-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.chat-participant-you {\n  margin-left: 6px;\n  color: var(--ch-text-muted);\n  font-weight: 500;\n  font-size: 0.76rem;\n}\n\n.chat-participant-role {\n  color: var(--ch-text-muted);\n  font-size: 0.75rem;\n}\n\n.chat-participants-foot {\n  padding: 12px 16px;\n  border-top: 1px solid var(--ch-border);\n}\n\n.chat-participants-confirm {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.chat-leave-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 12px;\n  border-radius: 10px;\n  border: 1px solid var(--accent-error, #dc2626);\n  background: transparent;\n  color: var(--accent-error, #dc2626);\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-leave-btn:hover {\n  background: rgba(220, 38, 38, 0.08);\n}\n\n/* Диалог выбора людей: название, чипы выбранных, футер */\n.chat-modal-field {\n  position: relative;\n  margin: 0 18px 12px;\n}\n\n.chat-modal-input {\n  width: 100%;\n  padding: 9px 60px 9px 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  border-radius: 10px;\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.chat-modal-counter {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary, #64748b);\n  font-size: 0.72rem;\n}\n\n.chat-selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 18px 10px;\n}\n\n.chat-selected-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.3));\n  background: transparent;\n  color: inherit;\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n.chat-check-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  border-radius: 5px;\n  border: 1.5px solid var(--border-color, rgba(148, 163, 184, 0.5));\n  color: #fff;\n}\n\n.chat-check-box.checked {\n  background: var(--accent-primary, #2563eb);\n  border-color: var(--accent-primary, #2563eb);\n}\n\n.chat-modal-item.selected {\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.12));\n}\n\n.chat-modal-foot {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 18px;\n  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));\n}\n\n.chat-modal-hint {\n  color: var(--text-secondary, #64748b);\n  font-size: 0.8rem;\n}\n\n.chat-modal-submit {\n  margin-left: auto;\n  padding: 9px 16px;\n  border-radius: 10px;\n  border: none;\n  background: var(--text-primary, #18181b);\n  color: var(--bg-primary, #fff);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-modal-submit:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n@media (max-width: 900px) {\n  .chat-participants {\n    width: 100%;\n    flex-basis: auto;\n  }\n\n  .chat-window-body {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
